import { ClientColumn } from "@common/types/views/clientViews";
import { WorkspaceSortValue } from "@common/types/views/workspaceViews";
import { ViewConfig } from "@lib/views";
import { WorkspaceDetails } from "@common/types/workspace";
import { NameCell } from "./cells/NameCell";
import { EntitiesCell } from "./cells/EntitiesCell";
import { TeamCell } from "./cells/TeamCell";

export interface ClientDetailsRow extends WorkspaceDetails {
    id: string;
}

export const clientViewConfig: ViewConfig<
    ClientDetailsRow,
    ClientColumn,
    WorkspaceSortValue
> = {
    columns: {
        [ClientColumn.NAME]: {
            accessorKey: "workspace.name",
            name: "Client",
            cell: NameCell,
            sort: {
                asc: WorkspaceSortValue.NAME_ASC,
                desc: WorkspaceSortValue.NAME_DESC,
            },
        },
        [ClientColumn.ENTITIES]: {
            accessorKey: "entities",
            name: "Entities",
            cell: EntitiesCell,
        },
        [ClientColumn.TEAM]: {
            accessorKey: "assignments",
            name: "Team",
            cell: TeamCell,
        },
    },
};
